// components/InterstitialAd.tsx
import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'

declare global {
  interface Window { googletag: any }
}

const AD_UNIT_PATH = '/21830119956,10216148/opopular.com.br/AL_0214n_INTERSTICIAL_DESK'
const SECTIONS = ['esporte', 'economia', 'magazine']

const InterstitialAd: React.FC = () => {
  const { asPath } = useRouter()
  const prevIsSectionRef = useRef(false)

  // detecta se o path começa com /seção ou /seção/...
  const isSection = SECTIONS.some(sec =>
    asPath === `/${sec}` || asPath.startsWith(`/${sec}/`)
  )

  useEffect(() => {
    // dispara apenas na transição raiz→seção
    if (isSection && !prevIsSectionRef.current) {
      window.googletag = window.googletag || { cmd: [] }
      window.googletag.cmd.push(() => {
        const slot = window.googletag.defineOutOfPageSlot(
          AD_UNIT_PATH,
          window.googletag.enums.OutOfPageFormat.INTERSTITIAL
        )
        if (!slot) {
          console.warn('Interstitial não suportado nesta página.')
          return
        }
        slot
          .addService(window.googletag.pubads())
          .setConfig({ interstitial: {} })

        window.googletag.pubads().enableSingleRequest()
        window.googletag.enableServices()
        window.googletag.display(slot)
      })
    }
    prevIsSectionRef.current = isSection
  }, [isSection])

  return null
}

export default InterstitialAd
